import { useQuery } from '@tanstack/react-query';
import Axios, { AxiosResponse } from 'axios';
import { plato_api_settings_path } from '@/modules/routes';

type Response = {
  text_to_speech_speed: string;
};

const NORMAL = 'normal';

const useSpeechSpeed = () => (
  useQuery(['userTtsSpeed'], () => Axios
    .get(plato_api_settings_path(), { params: { id: 'text_to_speech_speed' } })
    .then((res: AxiosResponse<Response>) => (res.data.text_to_speech_speed || NORMAL))
    .catch(() => NORMAL))
);

export default useSpeechSpeed;
